import {
  Flex,
  Text,
  Heading,
  useBreakpointValue,
  HeadingProps,
} from 'src/theme';

import { TIME_LABEL } from './constants';

type TTimeBlock = {
  label?: string;
  number?: number;
  numberProps?: HeadingProps;
  textSize?: 'xs' | 'sm' | 'md' | 'lg';
  unit?: string;
};

export const TimeBlock = ({
  number,
  label,
  unit,
  textSize,
  numberProps,
}: TTimeBlock) => {
  const responsiveSize = useBreakpointValue({
    base: 'xs',
    md: 'xl',
  });

  const digitSize = textSize ?? responsiveSize;

  return (
    <Flex>
      <Flex alignItems='center' direction='column'>
        <Heading
          minW={{ base: '20px', md: '40px' }}
          textAlign='center'
          size={digitSize}
          {...numberProps}
          suppressHydrationWarning
          variant='short'
        >
          {number.toLocaleString(undefined, { minimumIntegerDigits: 2 })}
        </Heading>
        <Text textTransform='capitalize' size='xs' variant='label'>
          {unit}
        </Text>
      </Flex>
      {label !== TIME_LABEL.SECOND && (
        <Heading mx={{ base: 1, md: 2 }} size={digitSize}>
          :
        </Heading>
      )}
    </Flex>
  );
};
